import { z } from "zod";

export const integerFieldSchema = (fieldName: string) =>
  z.union([
    z
      .string()
      .min(1, { message: `${fieldName} is required` })
      .refine((val) => /^\d+$/.test(val), {
        message: `${fieldName} must be an integer`,
      })
      .transform((val) => parseInt(val, 10)),
    z.number(),
  ]);
